import axios from 'lib/axios'
import config from '../../../config'
import _ from 'lodash'
const INPUT_CHANGE = 'INPUT_CHANGE'
const SET_PROP = 'SET_PROP'
const TOGGLE_LOADING = 'TOGGLE_LOADING'

export function handleEvent (event) {
  return (dispatch, getState) => {
    dispatch({
      type: INPUT_CHANGE,
      payload: {
        key: event.target.name,
        value: event.target.value
      }
    })
  }
}
export function LogIn () {
  return (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true })
    let username = getState().Login.username.value
    let password = getState().Login.password.value
    let validateInput = _validateCredentials(username, password)

    if (!_.isEmpty(validateInput)) {
      dispatch({ type: TOGGLE_LOADING, payload: false })
      return dispatch({
        type: SET_PROP,
        payload: {
          key: 'errorText',
          value: validateInput
        }
      })
    }
    axios
      .post(
        config.API.API_BASE,
        `f=login&username=` +
          `${getState() && getState().Login && getState().Login.username ? getState().Login.username.value : ''}` +
          `&password=` +
          `${getState() && getState().Login && getState().Login.password ? getState().Login.password.value : ''}`
      )
      .then(function (response) {
        let statusCode = response.data.status_code
        if (statusCode !== config.CUSTOM_STATUS.SUCCESS) {
          return dispatch({
            type: SET_PROP,
            payload: {
              key: 'errorText',
              value: response.data.status_msg
            }
          })
        }
        dispatch({ type: TOGGLE_LOADING, payload: false })
        dispatch(_getUserDetails(response.data.token))
      })
      .catch(err => {
        dispatch({ type: TOGGLE_LOADING, payload: false })
        console.log(`ERROR ${err}`)
      })
      .then(() => {
        dispatch({ type: TOGGLE_LOADING, payload: false })
      })
  }
}

let _validateCredentials = function (username, password) {
  let errorMessage = null
  if (_.isEmpty(username)) {
    errorMessage = config.VALIDATION.EMPTY_USERNAME
    return errorMessage
  }
  if (_.isEmpty(password)) {
    errorMessage = config.VALIDATION.EMPTY_PASSWORD
    return errorMessage
  }
}

let _getUserDetails = function (token) {
  return (dispatch, getState) => {
    let url = `${config.API.GET_USER_SETTINGS}&token=${token}`
    //console.log("TEST1")
    dispatch({ type: TOGGLE_LOADING, payload: true })
    //console.log("TEST2")
    axios.get(url).then(function (response) {
      //console.log("TEST3")
      if (response && response.data && response.data.result) {
        localStorage.setItem('export_limit', response.data.result.export_limit)
        let statusCode = response.data.status_code
        if (statusCode === config.CUSTOM_STATUS.SUCCESS) {
          let { email, name } = response.data.result.profile
          let user_id = response.data.result.user_id
          let search_modules = response.data.result.search_modules
          if (!getState().global.toJS().rememberMe) {
            sessionStorage['access_token'] = token
          } else {
            localStorage.setItem('access_token', token)
          }
          localStorage.setItem('logged_user_email', email)
          localStorage.setItem('logged_user_name', name)
          localStorage.setItem('logged_user_id', user_id)
          localStorage.setItem('logged_user_search_modules', search_modules)
          localStorage.setItem(
            'logged_user_role',
            response.data.result.is_admin && parseInt(response.data.result.is_admin)
              ? config.ROLES.ADMIN
              : config.ROLES.USER
          )
          localStorage.setItem('logged_user_hide_splashscreen', (response.data.result.preference && response.data.result.preference.hide_splash_screen) ? response.data.result.preference.hide_splash_screen : false)

          window.location.href = '/'
        }
      }
    }).catch(err => {console.log("ERR", err)})
    dispatch({ type: TOGGLE_LOADING, payload: false })
  }
}

const ACTION_HANDLERS = {
  [INPUT_CHANGE]: (state, action) => {
    return Object.assign({}, state, {
      [action.payload.key]: {
        value: action.payload.value.trim()
      },
      InvalidLoginMessage: null
    })
  },
  [SET_PROP]: (state, action) => {
    return Object.assign({}, state, {
      [action.payload.key]: action.payload.value
    })
  },
  [TOGGLE_LOADING]: (state, action) => {
    return Object.assign({}, state, { isLoading: action.payload })
  }
}

const initialState = {
  username: {
    value: '',
    validationState: '',
    helpBlockText: ''
  },
  password: {
    value: '',
    validationState: '',
    helpBlockText: ''
  }
}

export default function loginReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}
